import React from 'react';

const UploadIcon = () => {
  return (
    <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.831 11.847 14.5 8.614V18.5a.5.5 0 1 0 1 0V8.614l3.669 3.26a.499.499 0 1 0 .663-.746l-4.5-4.001a.498.498 0 0 0-.664 0l-4.5 4a.5.5 0 0 0-.043.704.478.478 0 0 0 .706.016zM21 17h-3.5a.5.5 0 1 0 0 1H21a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h3.5c.275 0 .5-.225.5-.5s-.225-.5-.5-.5H9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2c0-1.103-.897-2-2-2zm-.25 3a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0z"
        fill="#202020"
      />
    </svg>
  );
};

export default UploadIcon;
